import { BLOCK_INPUT_COMPATIBLE_KEYS, ELEMENT_KEYS_WITH_MULTIPLE_MAPPINGS } from '../smartpdf/constants';

export const prepareFieldProperties = (data = {}) => {
    try {
        const options = JSON.parse(JSON.stringify(data?.options || {}));

        if (!options.maxLength) {
            options.maxLength = undefined;
        }
        if (options?.enableBlockInput && (data?.data || []).length && data?.key === 'InputField') {
            options.maxLength = (data?.data || []).reduce((acc, item) => acc + Number(item?.blockSize || 0), 0);
        }
        if (!options.showTitleInPdfTemplateView) {
            options.showTitleInPdfTemplateView = undefined;
        }
        if (!options?.enableDataValue) {
            options.enableDataValue = undefined;
        }
        if (!options?.autofillField) {
            options.autofillField = undefined;
        }
        return { ...options };
    } catch (e) {
        console.error('prepareFieldProperties error:', e);
        return {};
    }
};

export const prepareFieldProperties2 = (data = {}) => {
    try {
        const options = JSON.parse(JSON.stringify(data?.fieldProperties || {}));
        return { ...options };
    } catch (e) {
        console.error('prepareFieldProperties2 error:', e);
        return {};
    }
};

export const prepareFieldConfig = (data = {}, rect = {}, options = {}) => {
    try {
        let config = JSON.parse(JSON.stringify(data?.config || rect?.config || {}));
        console.log({ prepareFIeldCOnfig: 'true', data, rect });
        const options = JSON.parse(JSON.stringify(data?.options || {}));
        if (data?.key === 'InputField' || data?.key === 'DatePicker') {
            if (options?.enableBlockInput) {
                const DataBlockHasConfig = (data?.data || []).some(
                    (item) => item?.config && item?.config?.rectConfig && item?.config?.rectConfig?.y
                );
                if (DataBlockHasConfig) {
                    config = { hasTemplateConfig: true };
                } else {
                    config = {};
                }
            } else {
                delete config.hasTemplateConfig;
            }
        }
        return { ...config };
    } catch (e) {
        console.error('prepareFieldProperties error:', e);
        return {};
    }
};

export const getFormIdFromUrl = () => {
    try {
        const hash = window.location.hash;
        if (hash.includes('form-library/edit')) {
            return hash.split('/').pop();
        }
        return '';
    } catch (err) {
        return '';
    }
};

export const isMultiBoxField = (field, { skipEnableBlockInput = true } = {}) => {
    try {
        if (!field?.key) return false;

        const OPTION_BASED_FIELDS = new Set(ELEMENT_KEYS_WITH_MULTIPLE_MAPPINGS);
        const BLOCK_INPUT_COMPATIBLE = new Set(BLOCK_INPUT_COMPATIBLE_KEYS);

        if (OPTION_BASED_FIELDS.has(field.key)) {
            return true;
        }

        if (BLOCK_INPUT_COMPATIBLE.has(field.key)) {
            return skipEnableBlockInput || (field?.options || {})?.enableBlockInput;
        }

        return false;
    } catch (err) {
        return false;
    }
};
